import { render, staticRenderFns } from "./item-detail.vue?vue&type=template&id=63e959d9&scoped=true&"
import script from "./item-detail.vue?vue&type=script&lang=js&"
export * from "./item-detail.vue?vue&type=script&lang=js&"
import style0 from "./item-detail.vue?vue&type=style&index=0&id=63e959d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e959d9",
  null
  
)

export default component.exports